import { useEffect, useRef } from "react";

interface Props {
  text: string;
  /** Панель отдыха внизу: плашка встаёт над ней, а не поверх. */
  raised: boolean;
  onUndo: () => void;
  onExpire: () => void;
}

const UNDO_MS = 5000;

/**
 * Отмена вместо подтверждения.
 *
 * Спрашивать «точно?» на каждое снятие галочки — лишний тап на каждый подход.
 * Отмена стоит тап только тогда, когда палец действительно промахнулся.
 */
export default function UndoToast({ text, raised, onUndo, onExpire }: Props) {
  // Экран тренировки перерисовывается каждую секунду — от часов. Колбэк в
  // зависимостях эффекта перезапускал бы таймер, и плашка не исчезала бы.
  const expire = useRef(onExpire);
  expire.current = onExpire;

  useEffect(() => {
    const timer = setTimeout(() => expire.current(), UNDO_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`toast ${raised ? "toast--raised" : ""}`} role="status">
      <span className="toast__text">{text}</span>
      <button className="toast__action" onClick={onUndo}>
        Вернуть
      </button>
    </div>
  );
}
